export const Icon = () => {
    return (
        <svg viewBox="0 0 18 10" width="18" height="10" fill="#ffffff">
            <path d="M0.998047 1.4149L9.48305 9.8999L17.968 1.4149L16.554 -9.72748e-05L9.48305 7.0719L2.41205 -9.72748e-05L0.998047 1.4149Z" />
        </svg>
    );
};
